import React, { Component } from 'react'
import { inject, observer, PropTypes } from 'mobx-react/index'

import LoginModal from './LoginModal'
import RegisterModal from './RegisterModal'
import DatesModal from './DatesModal'
import ForgotPasswordModal from './ForgotPasswordModal'

const components = {
  LoginModal,
  RegisterModal,
  DatesModal,
  ForgotPasswordModal
}

@inject('modals')
@observer
class SelectModal extends Component {
  render () {
    const name = this.props.modals.name
    console.log('modals.name', name)
    if (name.length === 0) {
      return null
    }
    const SelectedModal = components[name]
    return <SelectedModal {...this.props} />
  }
}

SelectModal.propTypes = {
  modals: PropTypes.observableObject
}

export default SelectModal



// WEBPACK FOOTER //
// ./src/containers/SelectModal.js